export const commaConjunction = new Intl.ListFormat("en-GB", {
  style: "long",
  type: "conjunction",
});
